import * as tslib_1 from "tslib";
import AppEvent from 'src/models/AppEvent';
import { CARD_DETAIL_VISIBLE, TASK_FILTER_VISIBLE, SPRINT_CHOOSER_VISIBLE, CARD_PROGRESS_VISIBLE, CARD_AVATAR_VISIBLE, CARD_VIEW_FILTER, CARD_DISPLAY_VERSION, DISPLAY_CLOSED_CARDS, INDEPENDENT_COLUMN_SCROLLING } from './../constants/localeStorageKeys';
import { TEAM as TEAM_OPTION } from 'src/models/TaskViewOptions';
import { VERSION1 as VERSION_OPTION } from 'src/models/CardDisplayVersions';
import { observable } from 'mobx';
var LocalStorageValue = /** @class */ (function () {
    function LocalStorageValue(key, defaulValue) {
        this.key = key;
        this.value = window.localStorage.getItem(key) || defaulValue;
    }
    LocalStorageValue.prototype.set = function (value) {
        window.localStorage.setItem(this.key, value);
        this.value = value;
    };
    tslib_1.__decorate([
        observable
    ], LocalStorageValue.prototype, "value", void 0);
    return LocalStorageValue;
}());
var LocalStorageBoolean = /** @class */ (function () {
    function LocalStorageBoolean(key, defaulValue) {
        this.key = key;
        var rawValue = window.localStorage.getItem(this.key);
        if (rawValue) {
            this.value = rawValue === 'true';
        }
        else {
            this.value = defaulValue;
        }
    }
    LocalStorageBoolean.prototype.set = function (newValue) {
        window.localStorage.setItem(this.key, newValue.toString());
        this.value = newValue;
    };
    tslib_1.__decorate([
        observable
    ], LocalStorageBoolean.prototype, "value", void 0);
    return LocalStorageBoolean;
}());
var PreferencesStore = /** @class */ (function () {
    function PreferencesStore() {
        var _this = this;
        this.updateHasSmallScreen = function () {
            _this.hasSmallScreen = !window.matchMedia('(min-width: 600px)').matches;
        };
        this.updateHasSmallScreen();
        this.changed = new AppEvent();
        this.sprintChooserVisible = new LocalStorageBoolean(SPRINT_CHOOSER_VISIBLE, true);
        this.taskFilterVisible = new LocalStorageBoolean(TASK_FILTER_VISIBLE, true);
        this.displayClosedCards = new LocalStorageBoolean(DISPLAY_CLOSED_CARDS, false);
        this.cardDetailVisible = new LocalStorageBoolean(CARD_DETAIL_VISIBLE, false);
        this.cardProgressVisible = new LocalStorageBoolean(CARD_PROGRESS_VISIBLE, true);
        this.cardAvatarVisible = new LocalStorageBoolean(CARD_AVATAR_VISIBLE, true);
        this.cardViewFilter = new LocalStorageValue(CARD_VIEW_FILTER, TEAM_OPTION);
        this.cardDisplayVersion = new LocalStorageValue(CARD_DISPLAY_VERSION, VERSION_OPTION);
        this.independentColumnScrolling = new LocalStorageBoolean(INDEPENDENT_COLUMN_SCROLLING, false);
        window.addEventListener('resize', this.updateHasSmallScreen);
    }
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "hasSmallScreen", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "isSettingsOpened", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "sprintChooserVisible", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "taskFilterVisible", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "cardDetailVisible", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "cardProgressVisible", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "displayClosedCards", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "cardAvatarVisible", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "cardViewFilter", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "cardDisplayVersion", void 0);
    tslib_1.__decorate([
        observable
    ], PreferencesStore.prototype, "independentColumnScrolling", void 0);
    return PreferencesStore;
}());
export default PreferencesStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/PreferencesStore.ts
// module id = 367
// module chunks = 0